import { render } from "./NewCardModal.vue?vue&type=template&id=47bf98d2&scoped=true"
import script from "./NewCardModal.vue?vue&type=script&lang=js"
export * from "./NewCardModal.vue?vue&type=script&lang=js"

import "./NewCardModal.vue?vue&type=style&index=0&id=47bf98d2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bf98d2"]])

export default __exports__